'use strict'
import UserAPI from '../../api/user'

// commit constants
const CLEAR = 'CLEAR',
    UPLOAD_USERFILE = 'UPLOAD_USERFILE',
    UPLOAD_USERFILE_SUCCESS = 'UPLOAD_USERFILE_SUCCESS',
    UPLOAD_USERFILE_ERROR = 'UPLOAD_USERFILE_ERROR',
    UPLOAD_USERUPDATE_FILE = 'UPLOAD_USERFILE',
    UPLOAD_USERUPDATE_FILE_SUCCESS = 'UPLOAD_USERFILE_SUCCESS',
    UPLOAD_USERUPDATE_FILE_ERROR = 'UPLOAD_USERFILE_ERROR',
    FETCHING_USERS = 'FETCHING_USERS',
    FETCHING_USERS_SUCCESS = 'FETCHING_USERS_SUCCESS',
    FETCHING_USERS_ERROR = 'FETCHING_USERS_ERROR'
// initial state
const state = {
    users: [],
    error: null,
    isLoading: false
}

// getters
const getters = {
    user(state) {
        return (userId) => {
            return state.users.find((user) => {
                return user.userId === userId
            })
        }
    },
    users(state) {
        return state.users
    },
    error(state) {
        return state.error
    },
    isLoading(state) {
        return state.isLoading
    },
    getUserById(state) {
        return (userId) => {
            let foundUser = false
            state.users.forEach((user) => {
                if (user.userId === userId) {
                    foundUser = user
                }
            })
            return foundUser
        }
    },
    getUserByIri(state) {
        return (userIri) => {
            let foundUser = false
            state.users.forEach((user) => {
                if (user['@id'] === userIri) {
                    foundUser = user
                }
            })

            return foundUser
        }
    },
    getUsersForAutocompletion(state) {
        return state.users
            .map((user) => {
                return {
                    id: user['userId'],
                    label: `${user.titel.trim()} ${user.vorname.trim()} ${user.nachname.trim()} (${user.email.email.trim()})`
                }
            })
            .sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1))
    }
}

const mutations = {
    [FETCHING_USERS](state) {
        state.isLoading = true
        state.error = null
    },
    [FETCHING_USERS_SUCCESS](state, users) {
        state.error = null
        state.isLoading = false
        state.users = users
    },
    [FETCHING_USERS_ERROR](state, error) {
        state.error = error
        state.isLoading = false
    },
    [UPLOAD_USERFILE](state) {
        state.isLoading = true
        state.error = null
    },
    [UPLOAD_USERFILE_SUCCESS](state) {
        state.error = null
        state.isLoading = false
    },
    [UPLOAD_USERFILE_ERROR](state, error) {
        state.error = error
        state.isLoading = false
    },
    [UPLOAD_USERUPDATE_FILE](state) {
        state.isLoading = true
        state.error = null
    },
    [UPLOAD_USERUPDATE_FILE_SUCCESS](state) {
        state.error = null
        state.isLoading = false
    },
    [UPLOAD_USERUPDATE_FILE_ERROR](state, error) {
        state.error = error
        state.isLoading = false
    },
    [CLEAR](state) {
        state.users = []
        state.isLoading = false
    }
}

// actions
const actions = {
    async findAll({ commit }) {
        commit(FETCHING_USERS)
        try {
            let response = await UserAPI.findAll()
            commit(FETCHING_USERS_SUCCESS, response.data['hydra:member'])
            return response.data['hydra:member']
        } catch (error) {
            commit(FETCHING_USERS_ERROR, error)
        }
    },
    async uploadUserFile({ commit, dispatch }, file) {
        commit(UPLOAD_USERFILE)
        try {
            await UserAPI.uploadUserFile(file)
            commit(UPLOAD_USERFILE_SUCCESS)
            await dispatch('user/findAll', {}, { root: true })

            return true
        } catch (error) {
            commit(UPLOAD_USERFILE_ERROR, error)
            return null
        }
    },
    async uploadUserUpdateFile({ commit, dispatch }, file) {
        commit(UPLOAD_USERUPDATE_FILE)
        try {
            await UserAPI.uploadUserUpdateFile(file)
            commit(UPLOAD_USERUPDATE_FILE_SUCCESS)
            await dispatch('user/findAll', {}, { root: true })

            return true
        } catch (error) {
            commit(UPLOAD_USERUPDATE_FILE_ERROR, error)
            return null
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
